import { render, staticRenderFns } from "./WolfDetails.vue?vue&type=template&id=32605f12&scoped=true&"
import script from "./WolfDetails.vue?vue&type=script&lang=js&"
export * from "./WolfDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32605f12",
  null
  
)

export default component.exports